import { reduxKey } from './constants';
import { EmoteStreamType } from './types';
function getState(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
export var getActiveStreamType = function (state) {
    return getState(state).activeStream || EmoteStreamType.OFFICIAL;
};
export var getIsLoadingMore = function (state) { return getState(state).isLoadingMore; };
export var getIsLoadingStream = function (state) { return getState(state).isLoadingStream; };
export var isInitialized = function (state) { return getState(state).isInitialized; };
export var getStream = function (state, streamType) {
    return getState(state)["".concat(streamType, "Emotes")];
};
export var getActiveStream = function (state) {
    var activeStreamType = getActiveStreamType(state);
    return getStream(state, activeStreamType);
};
export var getSearchQuery = function (state) { return getState(state).cachedSearchQuery; };
export var getSearchType = function (state) { return getState(state).cachedSearchType; };
//# sourceMappingURL=selectors.js.map